import React, { useContext, useEffect, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import CustomBreadcrumb from '../../common/CustomBreadcrumb'
import CommonTable from '../../common/CommonTable';
import { materialColumns } from './materialUtils';
import { useDispatch, useSelector } from 'react-redux';
import { getAllMaterialHandler } from '../../redux/action/getAllMaterialSlice';
import Loader from '../Loder/loader';
import { ThemeContext } from '../../common/themeContext';
import { BreadCrum } from '../../common';

const Material = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
	const { brandId } = useContext(ThemeContext);
    const getAllMaterialState = useSelector((state) => state?.getAllMaterial);
    const columns = materialColumns(navigate);
    const pagination = useMemo(() => ({
        current: getAllMaterialState?.data?.pageNumber ?? 1,
        pageSize: getAllMaterialState?.data?.pageSize ?? 10,
        total: getAllMaterialState?.data?.totalElements ?? 0,
        showSizeChanger: true,
        pageSizeOptions: [5, 10, 15, 20],
        className: "order-pagination",
        locale: { items_per_page: "" },
        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
    }), [getAllMaterialState?.data?.pageNumber, getAllMaterialState?.data?.pageSize, getAllMaterialState?.data?.totalElements]);

    const productTableData = useMemo(() => {
        const items = getAllMaterialState?.data?.data ?? [];
        return items.map((item, index) => ({
            key: item?.key ?? item?.id ?? item?.productId ?? `${index + 1}`,
            productName: item?.productName ?? "-",
            productCode: item?.productCode ?? "-",
            images: item?.images ?? item?.imageCount ?? 0,
            videos: item?.videos ?? item?.videoCount ?? 0,
            pdfs: item?.pdfs ?? item?.pdfCount ?? 0,
            faqs: item?.faqs ?? item?.faqCount ?? 0,
            dateCreated: item?.dateCreated ?? item?.createdAt ?? "-",
            ...item,
        }));
    }, [getAllMaterialState?.data?.data]);

    useEffect(() => {
        if (!brandId) return;
        dispatch(getAllMaterialHandler({
            refBrandId: brandId,
            search: "",
            offSet: 1,
            limit: 10,
            sortBy: "createdAt",
            sortDirection: "desc",
        }));
    }, [brandId, dispatch]);

    const handlePageChange = (page, pageSize) => {
        dispatch(getAllMaterialHandler({
            refBrandId: brandId,
            search: "",
            offSet: page,
            limit: pageSize,
            sortBy: "createdAt",
            sortDirection: "desc",
        }));
    };
    const addProduct = () => {
        navigate("/ai-campaigns/add-material");
    };
    return (
        <div className="rightside">
            <div className="rightcontent">
                <p>
                    <strong>Material</strong>
                </p>
                <CustomBreadcrumb
                    items={[{ text: BreadCrum.HOME}, { text: "AI Campaigns"}, { text: "Material List", active: true }]}
                />

                <div className="table-padding">
                    <div className="headtitle">
                        <p className="mb-0 heedprodct">Material</p>
                        <button className="primarybtn" onClick={addProduct}>
                            <div className="plus"></div>
                            Add Material
                        </button>
                    </div>
                    <hr className="m-0" />
                    <div className="table-responsive">
                        <CommonTable
                            handlePageChange={handlePageChange}
                            pagination={pagination}
                            body={productTableData}
                            columns={columns}
                        />
                        {getAllMaterialState?.isLoading === true && (
                            <Loader loaderTransform="loaderTransform" />
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Material